var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.allPagesLoaded)?_c('a',{staticClass:"load-more",class:{ 'load-more--active': _vm.isActive },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.loadMore.apply(null, arguments)}}},[_vm._v("MORE "+_vm._s(_vm.displayCategory))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }